import { Loader2, Mic, Square } from 'lucide-react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { t } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** Microphone toggle for `useDictation`; renders nothing where the browser can't dictate. */
export function DictationButton({
  dictation,
  className,
  ...props
}: { dictation: { supported: boolean; listening: boolean; busy: boolean; toggle: () => void } } & Omit<ButtonProps, 'onClick'>) {
  if (!dictation.supported) return null;
  const label = dictation.busy ? t('Transcribing …') : dictation.listening ? t('Stop dictation') : t('Dictate');
  return (
    <Button
      type="button"
      variant={dictation.listening ? 'destructive' : 'ghost'}
      size="icon"
      onClick={dictation.toggle}
      disabled={dictation.busy}
      aria-label={label}
      aria-pressed={dictation.listening}
      title={label}
      className={cn(dictation.listening && 'animate-pulse', className)}
      {...props}
    >
      {dictation.busy ? <Loader2 className="animate-spin" /> : dictation.listening ? <Square className="fill-current" /> : <Mic />}
    </Button>
  );
}
